import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { PageAttributeType } from "@silvertours/back-domain-page";
import { String } from "@silvertours/front-shared";
import { format } from "date-fns/format";
import { useRouter } from "next/router";
import { DEFAULT_VALUES } from "./reducer";
var getQueryParamValues = function(query) {
    var values = {};
    values.showDestLocation = !!query.dest;
    values.affiliate = query.affiliate || query.aff || "";
    if (query.dep || query.depAirport) {
        // e.g. ?dep=Berlin, or ?depAirport=BER
        var name = query.dep || "";
        var iataCode = query.depAirport || "";
        values.depLocation = {
            name: name,
            cityCode: iataCode,
            type: iataCode ? "airport" : "all",
            iataCode: iataCode
        };
    }
    if (query.dest || query.destAirport) {
        // e.g. ?dest=Madrid, or ?depAirport=MAD
        var name1 = query.dest || "";
        var iataCode1 = query.destAirport || "";
        values.destLocation = {
            name: name1,
            cityCode: iataCode1,
            type: iataCode1 ? "airport" : "all",
            iataCode: iataCode1
        };
    }
    if (typeof query.depDate === "string") {
        // e.g. ?depDate=2022-12-01
        values.depDate = format(new Date(query.depDate), String.isoDateTimeWithSeconds);
    }
    if (typeof query.destDate === "string") {
        // e.g. ?destDate=2022-12-07
        values.destDate = format(new Date(query.destDate), String.isoDateTimeWithSeconds);
    }
    if (typeof query.customerAge === "string") {
        values.customerAge = query.customerAge;
    }
    return values;
};
var ATTRIBUTE_TO_SEARCH_TYPE = {
    airport: "airport",
    city: "all",
    cityDistrict: "city",
    railStation: "rail"
};
var mapStageLocationToQuery = function(location) {
    if (!location || location.type !== PageAttributeType.Airport && location.type !== PageAttributeType.City) {
        return {
            inputValue: "",
            query: null
        };
    }
    var type = ATTRIBUTE_TO_SEARCH_TYPE[location.type] || "all";
    return {
        inputValue: location.displayName,
        query: {
            name: location.query || "",
            cityName: location.cityName || "",
            type: type
        }
    };
};
export var useSearchInitializer = function() {
    var router = useRouter();
    return {
        /** "Plain" search state to use when needed outside of search form */ getDefaultState: function(location) {
            var stageLocationQuery = mapStageLocationToQuery(location);
            return _object_spread({}, DEFAULT_VALUES, stageLocationQuery.query ? {
                depLocation: stageLocationQuery.query
            } : {});
        },
        /**
     * Search form initial state has multiple sources of truth, in order of importance:
     * 1. Stored in query params
     * 2. City name retrieved from page content (within stage property)
     * 3. Stored in session storage
     * 4. Hard-coded default values
     *
     * Note: session storage must be rendered separately because SSR doesn't have access to browser data
     */ initializeFormState: function(defaultValues, location) {
            var ref, ref1, ref2;
            var queryParams = getQueryParamValues(router.query);
            var stageLocationQuery = mapStageLocationToQuery(location);
            var initialState = _object_spread({}, defaultValues, stageLocationQuery.query ? {
                depLocation: stageLocationQuery.query
            } : {}, queryParams);
            return _object_spread_props(_object_spread({}, initialState), {
                inputValue: {
                    departure: ((ref = queryParams.depLocation) === null || ref === void 0 ? void 0 : ref.name) || stageLocationQuery.inputValue || ((ref1 = initialState.depLocation) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                    destination: ((ref2 = initialState.destLocation) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
                },
                showDestLocation: !!initialState.destLocation
            });
        }
    };
};
